var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSudcalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 311.565,
    height: 183.75,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1.469-8.031c0 2.703.984 4.828 2.922 6.375C6.375-.11 9.03.64 12.453.64c3.313 0 5.906-.782 7.75-2.329 1.828-1.593 2.735-3.562 2.735-5.906 0-2.343-.766-4.11-2.313-5.328-1-.797-2.484-1.406-4.5-1.875l-4.531-1.078c-1.735-.39-2.875-.75-3.422-1.078-.828-.438-1.266-1.156-1.266-2.063 0-1 .438-1.797 1.266-2.375.86-.53 2.015-.828 3.422-.828 1.297 0 2.344.219 3.203.657 1.297.64 1.984 1.765 2.094 3.312h5.218c-.109-2.734-1.125-4.86-3.062-6.297-1.953-1.437-4.328-2.172-7.063-2.172-3.312 0-5.828.766-7.515 2.313-1.703 1.547-2.563 3.453-2.563 5.797 0 2.515.86 4.39 2.594 5.578 1.047.719 2.922 1.406 5.688 2.015l2.765.61c1.656.36 2.844.765 3.61 1.219.75.468 1.156 1.124 1.156 1.984 0 1.437-.766 2.453-2.313 2.984-.828.297-1.875.438-3.172.438-2.187 0-3.734-.531-4.64-1.578-.469-.61-.797-1.485-.969-2.672Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M2.734-10.016c0 2.782.438 4.907 1.297 6.454C5.61-.75 8.671.64 13.171.64c4.5 0 7.532-1.391 9.11-4.204.86-1.546 1.297-3.671 1.297-6.453v-15.906h-5.5v15.906c0 1.813-.219 3.11-.656 3.891-.64 1.484-2.047 2.203-4.25 2.203-2.188 0-3.625-.719-4.281-2.203-.438-.781-.641-2.078-.641-3.89v-15.907H2.734Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M13-21.453c2.438 0 4.094.719 4.922 2.125.828 1.437 1.265 3.453 1.265 6.11 0 1.921-.28 3.577-.828 4.968-1 2.531-2.812 3.781-5.359 3.781H7.953v-16.984zm.89-4.469H2.704V0h11.188c3.921 0 6.843-1.625 8.718-4.828 1.407-2.406 2.094-5.328 2.094-8.781 0-1.329-.187-2.766-.515-4.282-.313-1.484-.938-2.875-1.829-4.172-1.156-1.593-2.625-2.703-4.437-3.28-1.078-.36-2.406-.548-4.031-.579zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M1.625-12.75c0 4.188 1.031 7.5 3.156 9.875C6.875-.469 9.797.719 13.47.719c2.984 0 5.39-.906 7.297-2.656 1.922-1.766 3.109-4.079 3.578-6.875H18.97c-.36 1.328-.782 2.328-1.328 2.984-.97 1.25-2.375 1.875-4.25 1.875-1.797 0-3.313-.735-4.47-2.172-1.187-1.438-1.765-3.625-1.765-6.547 0-2.875.547-5.14 1.657-6.734 1.124-1.578 2.671-2.375 4.578-2.375 1.906 0 3.312.578 4.28 1.687.548.625.97 1.547 1.345 2.813h5.359c-.078-1.625-.688-3.235-1.766-4.828-1.984-2.844-5.156-4.282-9.437-4.282-3.235 0-5.86 1.078-7.953 3.203-2.407 2.454-3.594 5.938-3.594 10.438zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m13.172-19.984 3.25 10.187H9.797ZM.937 0h5.657l1.718-5.328h9.547L19.547 0h5.875l-9.156-25.922h-6.11zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M2.703 0h18.36v-4.64H8.092v-21.282h-5.39zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.906-4.906c0 1.656.594 2.953 1.781 3.89C3.891-.062 5.517.391 7.61.391c2.032 0 3.61-.485 4.735-1.422 1.125-.969 1.672-2.188 1.672-3.61 0-1.437-.47-2.515-1.407-3.25-.625-.484-1.515-.859-2.75-1.156l-2.78-.656c-1.05-.235-1.752-.453-2.08-.657-.516-.266-.781-.704-.781-1.25 0-.625.265-1.11.781-1.454.516-.328 1.219-.515 2.078-.515.797 0 1.438.14 1.969.406.781.39 1.203 1.078 1.265 2.016h3.204c-.079-1.672-.688-2.969-1.875-3.844-1.188-.89-2.641-1.328-4.313-1.328-2.031 0-3.562.469-4.594 1.406-1.046.953-1.562 2.125-1.562 3.547 0 1.547.516 2.688 1.578 3.406.64.438 1.781.86 3.469 1.235l1.703.375c1.016.218 1.734.468 2.203.75.453.28.703.687.703 1.203 0 .89-.469 1.5-1.406 1.828-.516.187-1.156.265-1.938.265-1.343 0-2.296-.328-2.843-.968-.282-.375-.485-.906-.594-1.625Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M1.39 0h3.25v-3.219H1.39Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m8.047-12.203 1.984 6.219H5.984ZM.578 0h3.453l1.047-3.25h5.828L11.953 0h3.578L9.937-15.844H6.204Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M1.203 0h2.375v-4.86h5.125v-1.984H3.578V-9.5h5.844v-2.016H1.203Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M6.313-1.719c-.954 0-1.72-.343-2.297-1.047-.563-.703-.844-1.718-.844-3.015 0-1.297.281-2.297.844-3 .578-.703 1.343-1.063 2.296-1.063.97 0 1.72.36 2.282 1.063.562.719.844 1.703.844 3s-.282 2.312-.844 3.015c-.563.704-1.313 1.047-2.281 1.047zm5.515-4.062c0-2.11-.578-3.688-1.75-4.75-.86-.89-2.125-1.344-3.781-1.344-1.64 0-2.89.453-3.766 1.344C1.36-9.47.781-7.891.781-5.781c0 2.062.578 3.656 1.75 4.75C3.406-.125 4.656.312 6.297.312c1.656 0 2.922-.437 3.781-1.343 1.172-1.094 1.75-2.688 1.75-4.75zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M1.219-4.453c0 1.234.187 2.187.578 2.875C2.5-.344 3.859.282 5.859.282c2 0 3.344-.626 4.047-1.86.375-.688.578-1.64.578-2.875v-7.063H8.031v7.063c0 .812-.094 1.375-.281 1.734-.297.656-.922.969-1.89.969-.985 0-1.626-.313-1.907-.969-.187-.36-.297-.922-.297-1.734v-7.063H1.22Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M6.281-9.531c.5 0 .875.062 1.125.203.438.234.657.703.657 1.406 0 .64-.22 1.094-.688 1.297-.25.125-.64.188-1.156.188H3.625v-3.094zm.5-1.985h-5.5V0h2.344v-4.531h2.36c.671 0 1.124.125 1.359.375.234.234.375.734.39 1.468l.016 1.079c0 .328.047.671.11.984.03.156.077.375.156.625h2.656v-.281a1.038 1.038 0 0 1-.453-.656c-.047-.204-.063-.547-.063-1.079v-.78c0-.798-.11-1.407-.328-1.813-.234-.375-.594-.688-1.125-.891.625-.234 1.094-.594 1.36-1.125a3.44 3.44 0 0 0 .421-1.61c0-.453-.062-.874-.218-1.218a3.392 3.392 0 0 0-.579-.969c-.296-.344-.64-.625-1.078-.797-.421-.187-1.03-.281-1.828-.297zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M1.188 0h2.218v-8.203L8.141 0h2.39v-11.516H8.297v8.032l-4.594-8.032H1.188Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M3.406-11.516H1.031V0h2.375zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M.656-3.563c0 1.188.438 2.141 1.297 2.829C2.828-.047 4.016.28 5.531.28 7.016.281 8.156-.063 8.97-.75c.828-.703 1.219-1.594 1.219-2.625 0-1.047-.329-1.828-1.016-2.375-.453-.344-1.11-.625-2-.828l-2.016-.484c-.765-.172-1.281-.329-1.531-.47-.36-.202-.547-.515-.547-.921 0-.438.188-.797.547-1.047.39-.25.906-.375 1.531-.375.578 0 1.032.094 1.422.297.578.281.875.781.922 1.469h2.328c-.047-1.22-.5-2.157-1.36-2.797-.874-.64-1.921-.969-3.14-.969-1.469 0-2.594.344-3.344 1.031-.75.688-1.14 1.531-1.14 2.578 0 1.11.39 1.954 1.156 2.47.469.327 1.297.624 2.531.905l1.235.266c.734.156 1.265.344 1.593.547.344.203.516.5.516.875 0 .64-.344 1.094-1.031 1.328-.36.125-.828.188-1.407.188-.968 0-1.656-.235-2.062-.704-.203-.265-.344-.656-.438-1.171Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M9.75-11.516H1.297V0h8.719v-2.063H3.64V-5.03h5.61v-2H3.64v-2.453h6.11zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M5.781-9.531c1.078 0 1.813.312 2.188.937.375.64.562 1.531.562 2.719 0 .844-.125 1.594-.375 2.219-.437 1.11-1.25 1.672-2.375 1.672h-2.25v-7.547zm.39-1.985H1.204V0h4.969c1.75 0 3.047-.719 3.875-2.14.625-1.079.922-2.376.922-3.907 0-.594-.078-1.234-.219-1.906a5.047 5.047 0 0 0-.813-1.86c-.515-.703-1.171-1.203-1.968-1.453-.485-.156-1.078-.234-1.797-.25Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M.719-5.656c0 1.843.469 3.312 1.406 4.375C3.063-.203 4.359.312 5.985.312c1.327 0 2.406-.39 3.25-1.171.843-.782 1.374-1.813 1.578-3.063H8.437c-.171.594-.359 1.047-.593 1.328-.438.563-1.063.828-1.89.828-.798 0-1.47-.312-1.985-.953-.531-.64-.781-1.625-.781-2.906 0-1.281.234-2.297.734-3 .5-.703 1.187-1.063 2.031-1.063.844 0 1.469.266 1.906.766.235.266.422.688.594 1.235h2.375c-.031-.72-.297-1.438-.781-2.141-.875-1.266-2.281-1.906-4.188-1.906-1.437 0-2.609.484-3.546 1.437C1.25-9.219.718-7.657.718-5.657zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M3.594 0v-5.14h4.5V0h2.39v-11.516h-2.39v4.391h-4.5v-4.39H1.219V0Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "m5.86-8.875 1.437 4.516H4.359ZM.421 0h2.5l.781-2.375h4.235L8.688 0h2.609L7.234-11.516H4.516Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M11.344-7.922c-.125-1.11-.64-2.031-1.531-2.766-.891-.75-2.063-1.124-3.532-1.124-1.687 0-3.047.562-4.078 1.687C1.188-9.015.672-7.5.672-5.641c0 1.829.515 3.282 1.515 4.344C3.172-.234 4.422.281 5.954.281c.922 0 1.703-.187 2.328-.562.375-.235.813-.61 1.266-1.156L9.797 0h1.578v-6.172H6.578v1.922H9.25c-.11.75-.438 1.36-.969 1.813-.5.468-1.156.687-1.984.687-.813 0-1.547-.281-2.188-.875-.656-.594-.968-1.578-.968-3 0-1.406.296-2.453.89-3.156.594-.688 1.36-1.047 2.282-1.047.484 0 .937.078 1.312.265.734.313 1.172.86 1.344 1.641zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M6.063-9.531c.562 0 1.015.062 1.359.172.422.171.625.53.625 1.078 0 .484-.156.828-.469 1.015-.312.188-.719.297-1.203.297H3.562V-9.53Zm.343 4.453c.469 0 .86.062 1.125.203.5.219.735.64.735 1.25 0 .703-.25 1.188-.75 1.438-.266.14-.672.203-1.157.203H3.563v-3.094zm.422-6.438H1.266V0h5.187a7.55 7.55 0 0 0 1.625-.156c.5-.094.938-.297 1.297-.578.328-.235.594-.547.813-.907.343-.53.515-1.156.515-1.828 0-.672-.14-1.234-.453-1.703-.297-.453-.75-.797-1.328-1 .39-.219.672-.422.89-.656.344-.438.532-1 .532-1.703 0-.688-.188-1.281-.531-1.75-.594-.813-1.594-1.219-2.985-1.235zm0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M156.278 0c-27.098.277-50.64 22.184-50.965 49.703-.332 27.887 23.434 51.051 50.965 51.508 1.61.027 1.61-2.473 0-2.5-26.188-.434-48.78-22.492-48.465-49.008.31-26.156 22.73-46.94 48.465-47.203 1.605-.016 1.613-2.516 0-2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M156.278 13.18c-20.102.41-38.05 16.203-38.195 36.91-.149 20.93 17.75 37.48 38.195 37.953 1.61.035 1.61-2.465 0-2.5-19.067-.44-35.875-15.902-35.695-35.453.171-19.332 16.925-34.03 35.695-34.41 1.605-.03 1.613-2.53 0-2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M95.188 32.48c-12.055 39.778 19.22 81.934 61.09 80.7 1.605-.047 1.613-2.547 0-2.5-40.29 1.187-70.277-39.262-58.676-77.535.465-1.543-1.945-2.204-2.414-.664"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M155.29 123.414c-24.922-.69-48.954-13.094-61.73-34.87-.813-1.388-2.977-.13-2.16 1.261 13.226 22.54 38.093 35.394 63.89 36.11 1.61.046 1.605-2.454 0-2.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e60a7a",
    d: "M156.278 27c-12.969.387-26.11 9.012-26.387 23.047-.273 13.836 11.102 24.723 24.547 25.441 1.605.086 1.602-2.414 0-2.5-12.11-.648-22.297-10.515-22.047-22.94.25-12.646 12.313-20.2 23.887-20.548 1.605-.05 1.613-2.55 0-2.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e60a7a",
    d: "M154.438 75.488c4.914.18 9.781 2.856 10.895 7.985 1.29 5.91-3.524 10.45-9.055 10.965-1.59.144-1.606 2.648 0 2.5 6.683-.622 12.39-5.602 11.68-12.762-.688-6.934-7.024-10.953-13.52-11.188-1.61-.058-1.61 2.442 0 2.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e60a7a",
    d: "M156.278 109.254c13.348-.457 24.586-10.398 24.578-24.195-.004-13.782-11.316-24.215-24.715-24.793-1.61-.07-1.605 2.43 0 2.5 12.098.523 22.125 9.925 22.215 22.293.094 12.402-10.152 21.29-22.078 21.695-1.606.055-1.613 2.555 0 2.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e60a7a",
    d: "M156.278 38.402c-6.606.594-12.985 5.09-12.746 12.32.226 6.887 6.023 11.692 12.61 12.044 1.605.086 1.6-2.414 0-2.5-5.07-.27-9.677-3.856-10.052-9.157-.422-5.949 4.711-9.714 10.188-10.207 1.59-.144 1.605-2.644 0-2.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M155.672 135.598c27.125-.278 50.258-22.262 50.582-49.703.325-27.696-22.472-50.625-49.976-51.075-1.61-.027-1.61 2.473 0 2.5 26.168.426 47.785 22.25 47.476 48.575-.308 26.078-22.32 46.941-48.082 47.203-1.609.015-1.613 2.515 0 2.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M155.798 122.8c20.234-.417 37.53-16.71 37.687-37.292.16-20.715-16.7-37.477-37.207-37.95-1.61-.034-1.61 2.466 0 2.5 19.133.442 34.89 16.106 34.707 35.45-.18 19.207-16.293 34.402-35.188 34.793-1.605.035-1.609 2.535 0 2.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M216.376 103.117c11.847-39.09-18.504-81.87-60.098-80.074-1.602.066-1.61 2.566 0 2.5 40.015-1.727 69.082 39.313 57.687 76.91-.468 1.543 1.946 2.203 2.41.664"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c963f",
    d: "M156.278 11.785c24.72.754 49.117 13.774 61.73 35.27.813 1.386 2.973.13 2.157-1.262-13.063-22.266-38.29-35.727-63.887-36.508-1.61-.047-1.61 2.453 0 2.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2c983f"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.124 47.497)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 139.834,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 163.846,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 189.838,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 215.83,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 241.822,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 267.814,
    y: 116.326
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.124 47.497)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 299.197,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 313.871,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    x: 319.987,
    y: 116.326
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 335.871,
    y: 116.326
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6f7375"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-141.037 47.913)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    x: 139.834,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 149.61,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 162.058,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    x: 173.61,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    x: 185.162,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    x: 196.714,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 201.162,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 211.834,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 222.506,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 233.178,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    x: 244.73,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: 260.73,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 272.282,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: 287.402,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    x: 298.954,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 310.506,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 322.058,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    x: 333.61,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    x: 343.386,
    y: 135.525
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-141.037 47.913)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 352.295,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    x: 363.847,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    x: 376.295,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 391.415,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    x: 402.967,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    x: 414.519,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    x: 426.071,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    x: 437.623,
    y: 135.525
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    x: 442.071,
    y: 135.525
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSudcalLogo);
export default __webpack_public_path__ + "static/media/sudcal_logo.424c8bd2303f0c9c8e67a8a35180c61f.svg";
export { ForwardRef as ReactComponent };